import type { ComponentProps } from "react";
import {
  buttonClasses,
  type ButtonSize,
  type ButtonVariant,
} from "./button-classes";

// React component wrapper around the pure `buttonClasses()` seam in
// ./button-classes. Non-<button> consumers (e.g. <Link>) skip this file and
// import `buttonClasses` directly from `./button-classes`.

interface ButtonProps extends ComponentProps<"button"> {
  variant?: ButtonVariant;
  size?: ButtonSize;
}

export function Button({
  variant,
  size,
  className,
  type = "button",
  ...props
}: ButtonProps) {
  return (
    <button
      type={type}
      className={buttonClasses({ variant, size, className })}
      {...props}
    />
  );
}
